<template>
  <div class="news-detail-page ctn">
    <a class="back" @click="goBack">新闻资讯</a>
    <section class="news">
      <h1>{{ curNews.title || '' }}</h1>
        <time>{{ curNews.created_date || '' }}</time>
        <span v-for="(tag, key) in curNews.tags" :key="key" @click="goCata(tag)">{{ tag }}</span>
        <div class="content" v-html="curNews.content">
        </div>
    </section>
    <aside>
      <h2>近期资讯</h2>
      <ul>
        <li v-for="(item, index) in latest" :key="index">
          <a :href="'#/NewsDetail/' + item.id">{{ item.title || '' }}</a>
          <time>{{ item.created_date }}</time>
        </li>
      </ul>
    </aside>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'App',
  components: {

  },
  data() {
    return {
      id : null,
      curPage: 1,
      latest: [],
      curNews: {}
    }
  },
  computed: {
    prevClass() {
      return this.curPage <= 1 ? 'disabled' : ''
    },
    nextClass() {
      return this.endIndex >= this.news.length ? 'disabled' : ''
    },
    filterData() {
      return this.news.slice((this.curPage - 1) * 3, this.endIndex)
    },
    endIndex() {
      const end = this.curPage * 3
      return end > this.news.length ? this.news.length : end
    },
  },
  watch: {
    '$route.params': {
      handler() {
        this.id = this.$route.params.id
        this.getData()
      },
      deep: true
    }
  },
  created() {
    this.id = this.$route.params.id
    this.getData()
    this.getLatest()
  },
  methods: {
    goCata(tag) {
      const n = ['新闻资讯', '媒体报道', '党建工作', '行业动态'].indexOf(tag)
      this.curTab = n + 1
      location.href='#/NewsCata/' + tag.replaceAll('#','').trim()
    },
    goBack() {
      window.history.go(-1)
    },
    getData() {
      axios.get('/api/v1/article/info?id=' + this.id).then(r => {
        if (r && r.data)
        this.curNews = r.data
      })
    },
    getLatest() {
      axios.get('/api/v1/article/list?home_recommend=1').then(r => {
        if (r && r.data && r.data.list)
        this.latest = r.data.list
      })
    },
    goPrev() {
      this.curPage > 1 && this.curPage--
    },
    goNext() {
      this.endIndex < this.news.length && this.curPage++
    }
  }
}
</script>
